import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import store, { persistor } from './app/store';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import setupAxiosInterceptors from './helpers/axiosConfig';

setupAxiosInterceptors();

const root = createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </BrowserRouter>
);